export default class RegisterType {
  constructor(obj) {
    obj = obj || {};
    this.id = obj.id;
    this.description = obj.description;
  }
}